var md5 = require("md5");
// var crypto = require('crypto');
const CryptoJS = require("crypto-js");

class Util {
  ID_RAND(prefix) {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return prefix + Math.random().toString(36).substr(2, 9);
  }

  toBase64(strData) {
    return Buffer.from(strData).toString("base64");
  }

  fromBase64(data) {
    return Buffer.from(data, "base64").toString("ascii");
  }

  getMD5(data) {
    return md5(data);
  }

  encryp(data, key) {
    return CryptoJS.AES.encrypt(data, key).toString();
  }

  decryp(data, key) {
    return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
  }

  // getSha384(data){
  //     var shasum = crypto.createHash('sha384');
  //     shasum.update(data);
  //     return shasum.digest('hex');
  // }

  // getSha256(data){
  //     var shasum = crypto.createHash('sha256');
  //     shasum.update(data);
  //     return shasum.digest('hex');
  // }

  getNewDate() {
    var dateD = new Date();

    return dateD;
  }

  // validatedate(dateString){
  //     //let dateformat = /^(0?[1-9]|1[0-2])[\/](0?[1-9]|[1-2][0-9]|3[01])[\/]\d{4}$/;
  //     let dateformat = /^(0[1-9]|1\d|2[0-8]|29(?=\/\d\d\/(?!1[01345789]00|2[1235679]00)\d\d(?:[02468][048]|[13579][26]))|30(?!\/02)|31(?=\/0[13578]|\/1[02]))\/(0[1-9]|1[0-2])\/([12]\d{3}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/gm;

  //     // Match the date format through regular expression
  //     if(dateString.match(dateformat)){
  //         let operator = dateString.split('/');

  //         // Extract the string into month, date and year
  //         let datepart = [];
  //         if (operator.length>1){
  //             pdatepart = dateString.split('/');
  //         }
  //         let month= parseInt(datepart[0]);
  //         let day = parseInt(datepart[1]);
  //         let year = parseInt(datepart[2]);

  //         // Create list of days of a month
  //         let ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
  //         if (month==1 || month>2){
  //             if (day>ListofDays[month-1]){
  //                 ///This check is for Confirming that the date is not out of its range
  //                 return false;
  //             }
  //         }else if (month==2){
  //             let leapYear = false;
  //             if ( (!(year % 4) && year % 100) || !(year % 400)) {
  //                 leapYear = true;
  //             }
  //             if ((leapYear == false) && (day>=29)){
  //                 return false;
  //             }else
  //             if ((leapYear==true) && (day>29)){
  //                 console.log('Invalid date format!');
  //                 return false;
  //             }
  //         }
  //     }else{
  //         console.log("Invalid date format!");
  //         return false;
  //     }
  //     return true;
  // }

  getFecha(date) {
    var dia =
      (date.getDate() + "").length == 1 ? "0" + date.getDate() : date.getDate();
    var mes =
      (date.getMonth() + 1 + "").length == 1
        ? "0" + (date.getMonth() + 1 + "")
        : date.getMonth() + 1;
    var fechaR = dia + "/" + mes + "/" + date.getFullYear();
    return fechaR;
  }

  getConsoleColors() {
    return {
      Reset: "\x1b[0m",
      Bright: "\x1b[1m",
      Dim: "\x1b[2m",
      Underscore: "\x1b[4m",
      Blink: "\x1b[5m",
      Reverse: "\x1b[7m",
      Hidden: "\x1b[8m",

      FgBlack: "\x1b[30m",
      FgRed: "\x1b[31m",
      FgGreen: "\x1b[32m",
      FgYellow: "\x1b[33m",
      FgBlue: "\x1b[34m",
      FgMagenta: "\x1b[35m",
      FgCyan: "\x1b[36m",
      FgWhite: "\x1b[37m",

      BgBlack: "\x1b[40m",
      BgRed: "\x1b[41m",
      BgGreen: "\x1b[42m",
      BgYellow: "\x1b[43m",
      BgBlue: "\x1b[44m",
      BgMagenta: "\x1b[45m",
      BgCyan: "\x1b[46m",
      BgWhite: "\x1b[47m",
    };
  }

  saveByteArray(data) {
    // var a = document.createElement("a");
    // document.body.appendChild(a);
    // a.style = "display: none";
    // return function (data, name) {
    //   var blob = new Blob(data, { type: "octet/stream" }),
    //     url = window.URL.createObjectURL(blob);
    //   a.href = url;
    //   a.download = name;
    //   a.click();
    //   window.URL.revokeObjectURL(url);
    // };
    const link = document.createElement( 'a' );
    link.style.display = 'none';
    document.body.appendChild( link );
    
    
    const blob = new Blob( [ data ], { type: 'octet/stream' } );	
    const objectURL = URL.createObjectURL( blob );
     
    link.href = objectURL;
    link.href = URL.createObjectURL( blob );
    link.download =  'reporte_x_plantilla.xlsx';
    link.click();

  }
  
}

export default Util;
